import axios from 'axios'

const AMATRA_EDU_URL = process.env.VUE_APP_AMATRA_EDU_BACKEND_URL
const axiosDocument = axios.create({ baseURL: 'http://192.168.100.177:8000/api' })
const axiosEdu = axios.create({ baseURL: AMATRA_EDU_URL + 'api/v1/' })

export { axios, axiosDocument, axiosEdu }
